import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { BookOpen, ChevronDown } from "lucide-react";
import { EditionShell } from "../components/dnh/feed/EditionShell";
import { NewsFeed } from "../components/dnh/feed/NewsFeed";
import { TodaySummary } from "../components/dnh/feed/TodaySummary";

export default function Today() {
  const [params] = useSearchParams(); const requested = params.get("summary") === "1";
  const [summaryOpen, setSummaryOpen] = useState(requested);
  useEffect(() => { if (requested) setSummaryOpen(true); }, [requested]);
  return <EditionShell title="Today" testId="today-page" ticker actions={<button className="dnh-outline-button gap-2" aria-expanded={summaryOpen} aria-controls="today-summary-container" onClick={() => setSummaryOpen(v => !v)} data-testid="today-summary-toggle"><BookOpen size={16} /><span>{summaryOpen ? "Close summary" : "View summary"}</span><ChevronDown size={14} className={summaryOpen ? "rotate-180" : ""} /></button>}>
    <div id="today-summary-container" data-testid="today-summary-container"><TodaySummary country={params.get("country")} iso2={params.get("iso2")} stateSlug={params.get("state")} open={summaryOpen} /></div>
    <NewsFeed />
  </EditionShell>;
}